import { duration } from "../dateUtils.mjs";
import { trackFirstScreenTap } from "./events.mjs";
function excludePayloadOnlyProperties(payload) {
  const { sourceChainTimestamps, tournamentAPI, ...rest } = payload;
  return rest;
}
function getNextGenerationProperties(entryData, now, opts) {
  if (entryData.$zeroEntryDatetime != null) {
    return {
      $firstEntryGeneration: (+entryData.$firstEntryGeneration || 0) + 1,
      $zeroEntryChannel: entryData.$zeroEntryChannel,
      $zeroEntryDatetime: entryData.$zeroEntryDatetime,
      $zeroEntryDate: entryData.$zeroEntryDate,
      $zeroEntryAdCampaignName: entryData.$zeroEntryAdCampaignName,
      $zeroEntryAdSetName: entryData.$zeroEntryAdSetName,
      $zeroEntryAdCreativeName: entryData.$zeroEntryAdCreativeName,
      $zeroEntryAdNetworkName: entryData.$zeroEntryAdNetworkName,
      zeroEntrySourcePlayerID: entryData.zeroEntrySourcePlayerID
    };
  } else {
    const datetime = new Date(now).toISOString();
    return {
      $firstEntryGeneration: 0,
      $zeroEntryChannel: opts.channel,
      $zeroEntryDatetime: datetime,
      $zeroEntryDate: datetime.slice(0, 10),
      $zeroEntryAdCampaignName: entryData.$adCampaignName,
      $zeroEntryAdSetName: entryData.$adSetName,
      $zeroEntryAdCreativeName: entryData.$adCreativeName,
      $zeroEntryAdNetworkName: entryData.$adNetworkName,
      zeroEntrySourcePlayerID: opts.playerID
    };
  }
}
function getSessionMaturityRange(entryCount) {
  if (entryCount <= 1)
    return "1";
  else if (entryCount <= 2)
    return "2";
  else if (entryCount <= 5)
    return "3-5";
  else if (entryCount <= 9)
    return "6-9";
  else if (entryCount <= 19)
    return "10-19";
  else if (entryCount <= 49)
    return "20-49";
  else if (entryCount <= 99)
    return "50-99";
  else if (entryCount <= 199)
    return "100-199";
  else if (entryCount <= 399)
    return "200-399";
  else if (entryCount <= 799)
    return "400-799";
  else
    return "800+";
}
function attachFirstTapListener() {
  const firstScreenTapListener = () => {
    trackFirstScreenTap({ occasion: "sessionStart" });
    window.removeEventListener("pointerdown", firstScreenTapListener);
  };
  window.addEventListener("pointerdown", firstScreenTapListener);
}
function entryDataToPayloadIdentifierObject(entryData, entryPointName) {
  const identifyingKeys = [
    "$adCampaignName",
    "$adCreativeName",
    "$adSetName",
    "$channel",
    "$creativeAssetID",
    "$pageLinkId",
    "$subFeature",
    "creativeAssetID",
    "feature",
    "playerID",
    "subFeature",
    "tracerKey"
  ];
  const result = {};
  for (const key of identifyingKeys) {
    const value = entryData[key];
    if (value !== void 0 && value !== null && value !== "") {
      result[key] = value;
    }
  }
  if (entryPointName) {
    result.entryPointName = entryPointName;
  }
  return result;
}
function getLastEntryIsRepeat(opts) {
  const {
    entryData,
    entryPointName,
    hoursInactive,
    previousPayloadIdentifier
  } = opts;
  const currentPayloadIdentifier = entryDataToPayloadIdentifierObject(
    entryData,
    entryPointName
  );
  const lastEntryIsRepeat = hoursInactive <= 0.5 && !!previousPayloadIdentifier && JSON.stringify(
    currentPayloadIdentifier,
    Object.keys(currentPayloadIdentifier).sort()
  ) === JSON.stringify(
    previousPayloadIdentifier,
    Object.keys(previousPayloadIdentifier).sort()
  );
  return { currentPayloadIdentifier, lastEntryIsRepeat };
}
function getReferralChainLengths(referralChainTimestamps, now) {
  const durations = {
    "1M": duration({ minutes: 1 }),
    "5M": duration({ minutes: 5 }),
    "15M": duration({ minutes: 15 }),
    "30M": duration({ minutes: 30 }),
    "1H": duration({ hours: 1 }),
    "2H": duration({ hours: 2 }),
    "4H": duration({ hours: 4 }),
    "8H": duration({ hours: 8 }),
    "12H": duration({ hours: 12 }),
    "1D": duration({ hours: 24 })
  };
  return Object.entries(durations).reduce((acc, [key, interval]) => {
    acc[key] = referralChainTimestamps.filter((timestamp) => now - timestamp <= interval).length || "(none)";
    return acc;
  }, {});
}
function isSocialChannel(channel) {
  switch (channel) {
    case "LINK":
    case "TOURNAMENT":
    case "INVITE":
    case "SHARE":
    case "STORY":
    case "UPDATE":
      return true;
    case "A2U":
    case "AD":
    case "CHANNEL":
    case "CHATBOT":
    case "CROSSPLAY":
    case "GAMESWITCH":
    case "NONVIRAL":
    case "PAGE":
    case "PUSH":
    case "HOMESCREEN":
      return false;
    default: {
      return false;
    }
  }
}
export {
  attachFirstTapListener,
  excludePayloadOnlyProperties,
  getLastEntryIsRepeat,
  getNextGenerationProperties,
  getReferralChainLengths,
  getSessionMaturityRange,
  isSocialChannel
};
